import "./image-box-infographic.scss";
import { useRef, useState } from "react";
import ICON_UPLOAD from "../../../../assets/images/upload.svg"
import ICON_FILM from "../../../../assets/images/film.svg";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from "../../../../utility/snackbar.utility";
import CustomSnackbar from "../../../snackbar/snackbar.component";
import CropImageModal from "../../../../modal/crop-image/crop-image";

const ImageBoxInfographicComponent = ({ box, templateImage, onUpdateBox }) => {

    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    const inputImageRef = useRef<HTMLInputElement | null>(null);

    const [isShowCropModal, setIsShowCropModal] = useState(false);
    const [imageSrc, setImageSrc] = useState<any>(null);
    const [imageFileName, setImageFileName] = useState<string>('');

    const handleDropImage = (event: React.DragEvent<HTMLDivElement>, id: number) => {
        event.preventDefault();

        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            const file = event.dataTransfer.files[0];
            const errorFileType = validateFileType(file);

            if (errorFileType) {
                showSnackbar(errorFileType, 'error');
                return;
            }

            setImageFileName(file.name);

            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    setImageSrc(reader.result as string);
                    setIsShowCropModal(true);
                };
                reader.readAsDataURL(file);
            }
        }
    };

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>, id: number) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];

            setImageFileName(file.name);

            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    setImageSrc(reader.result as string);
                    setIsShowCropModal(true);
                };
                reader.readAsDataURL(file);
            }
        }
        event.target.value = '';
    };

    const validateFileType = (file: File): string | undefined => {
        const allowedMimeTypes = ['image/jpeg', 'image/png'];

        if (!allowedMimeTypes.includes(file.type)) {
            return 'ประเภทไฟล์ไม่ถูกต้อง กรุณาเลือกไฟล์ที่มีนามสกุล .jpg, .jpeg หรือ .png';
        }
    };

    const handleDeleteImage = (event) => {
        event.stopPropagation();

        if (inputImageRef.current) {
            inputImageRef.current.value = '';
        }
        onUpdateBox({ ...box, file: null, src: '' });
    }

    const handleButtonClick = () => {
        inputImageRef.current?.click();
    };

    const handleCropImage = (croppedImage) => {
        if (!croppedImage) return;

        onUpdateBox({ ...box, file: croppedImage.file, src: croppedImage.src, fileName: imageFileName });
        setIsShowCropModal(false);
    }

    return (
        <>
            <div
                className='drop-image-box'
                onDragOver={(event) => event.preventDefault()}
                onDrop={(event) => handleDropImage(event, box.id)}
            >
                <div>
                    <div className='mb-1'>
                        {
                            (box.src) ?
                                <div className="drop-image-box-image">
                                    <img src={box.src} height={100} />

                                    <div className="image-box-icon-close-wrapper">
                                        <IconButton color="primary" className="image-box-icon-close" onClick={(event) => handleDeleteImage(event)}>
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                </div> :
                                <div className='d-flex align-items-center'>
                                    <img src={ICON_UPLOAD} className='me-2' width={16} height={16} />
                                    <span className='image-box-title'>ลาก และ วางไฟล์ที่นี่ หรือ กดอัปโหลดไฟล์</span>
                                </div>
                        }
                    </div>

                    <p className='image-box-sub-title'>ไฟล์ที่รองรับ: .jpeg, .png และขนาดที่แนะนำ: {templateImage.width}x{templateImage.height}px</p>
                </div>

                <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    ref={inputImageRef}
                    className='d-none'
                    onChange={(event) => handleFileSelect(event, box.id)}
                />
                <Button variant="outlined" color="primary" className='button-upload-file' onClick={handleButtonClick}>อัปโหลดรูป</Button>
            </div>

            {
                isShowCropModal &&
                <CropImageModal
                    show={isShowCropModal}
                    imageSrc={imageSrc}
                    size={{ width: templateImage.width, height: templateImage.height }}
                    onClose={() => setIsShowCropModal(false)}
                    onSave={handleCropImage}
                />
            }

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )
}

export default ImageBoxInfographicComponent;